import Promise from 'bluebird';
import _ from 'lodash';
import store from '../../store';
import { OVERVIEW_PANEL_GET_CURRENT, OVERVIEW_PANEL_IS_VISIBLE } from '../../store/modules/overview-panel/types';

import worldMap from '../core/map';
import templates from '../core/templates';
import ColorBrewer from '../core/tools/colorbrewer';
import ColorFlatUI from '../core/tools/colorflatui';
import environment from '../environment';
import Leaflet from './Leaflet';
import { tryOrReturn } from '../../utils';
import { LocaleTypeEnum } from '../../enuns/localeType.enum';

const LayerControls = (name) => require('../controls').get(name);
const LayerInfo = (name) => require('../info').get(name);
const get = (name, currentMap = worldMap.getCurrent()) => {
    return require('./index').default.get(name, currentMap);
};

const name = 'SelectedAreas';

class SelectedAreasLayer {
    constructor (currentMap) {
        const mapId = currentMap._id;

        const onClick = (feature) => {
            try {
                if (worldMap.getCurrent()._id === mapId && LayerControls(name).getTypeValue() !== LocaleTypeEnum.SetorCensitario) {
                    const status = LayerInfo(name).check(feature.properties.Id) ? 'uncheck' : 'check';
                    $(`#SelectedAreas-selection-${feature.properties.Id}`).iCheck(status);
                }
            } catch (err) {
                console.log(err);
            }
        };

        const onSuccess = (featureCollection) => {
            return new Promise((resolve) => {

                if (LayerControls(name).getTypeValue() === LocaleTypeEnum.SetorCensitario) {
                    featureCollection.features.forEach(f => f.properties.disabled = true);
                }

                LayerControls(name).colorize(featureCollection, get(name, currentMap)).then((fc) => {
                    resolve(fc);
                });
            });
        };

        const onComplete = () => {
            LayerControls(name).show({
                show: false,
                refresh: true
            });

            if (store.getters[OVERVIEW_PANEL_GET_CURRENT] === name && store.getters[OVERVIEW_PANEL_IS_VISIBLE] && LayerControls(name).getControls(mapId).button.overview.enable) {
                LayerControls(name).toggleOverview();
            }
        };

        const lyr = new Leaflet.D3Layer();

        let idLayerType = (() => {
          try {
            return environment.get('CONFIG.FILTERS.AREAS_TYPES')[_.take(_.keys(environment.get('CONFIG.FILTERS.AREAS_TYPES')), 1)[0]].id;
          } catch (error) {
            return environment.get('TYPE.AUTO');
          }
        })();

        // Workaround to fix bug in compare maps function.
        if (mapId === 1 && idLayerType < 0) {
          idLayerType = LayerControls(name).getControls(0).dropdown.list.value;
          const mapSelect = worldMap.get(0);

          const oldZoom = mapSelect.getZoom();
          const newZoom = oldZoom + 0.1;

          // Adjust shape on map after resize to compare map.
          mapSelect.setZoom(newZoom);
          setTimeout(() => {
            mapSelect.setZoom(oldZoom);
          }, 200);
        }

        lyr.setOptions({
            map: currentMap,
            remote: {
                url: `${environment.get('API_HOST')}/localidade/GetLocation`,
                params: {
                    locationType: idLayerType,
                    format: 'topojson'
                }
            },
            cache: false,
            filter: {
                location: true
            },
            showAll: false,
            expandView: 0.5,
            autofocus: false,
            scaleRange: new Leaflet.ZoomLevel(lyr, { id: idLayerType }),
            uniqueField: 'Id',
            sort: 'Nome',
            below: true,
            tagViewportClamp: true,
            label: {
                template (properties) {
                    return templates('map-layer-areas-label', properties);
                },
                options: {
                    offset: [12, -40],
                    direction: 'right'
                }
            },
            manualPaints: LayerControls(name)._manualPaints,
            dblclick: onClick,
            done: onComplete,
            success: onSuccess,
            value: 'Total',
            symbology: {
                type: 'choropleth',
                scale: 'jenks',
                theme: ColorBrewer.OrRd[9],
                style: {
                    highlight: true,
                    lineJoin: 'round',
                    color: ColorFlatUI.wet_asphalt[1][0],
                    fillColor: 'rgba(0,0,0, 0.2)',
                    fillOpacity: 0.4,
                    opacity: 1,
                    weight: 1
                }
            }
        });
        return lyr;
    }
}

export default SelectedAreasLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/SelectedAreasLayer.js